import {Component,Input,OnChanges,SimpleChanges,inject} from '@angular/core';
import {Router,RouterLink,RouterLinkActive} from '@angular/router';
@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './header-component.html',
})
export class HeaderComponent {

  @Input() homeRoute = '/login';
  @Input() showPublicLinks = true;

  private router = inject(Router);

  isMobileMenuOpen = false;

navigateToPublicPage(page: string): void {
    this.router.navigate([`/${page}`], {
      queryParams: { returnUrl: this.homeRoute }
    });
  }

  navigateHome(): void {
    this.router.navigateByUrl(this.homeRoute);
  }

  toggleMobileMenu(): void {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  closeMobileMenu(): void {
    this.isMobileMenuOpen = false;
  }
}
